// vgm基础数据--下拉框等
import request from '@/api/requestTwo'
import { MODE_CONF } from '@/utils/config'
//const serve="http://192.168.60.120:30770"
const serve = MODE_CONF.base_url;
const serve2 = MODE_CONF.base_url_agent
//获取提交人
export function getSubmitter() {
    return request({
        url: `/services/user/submitUserList`,
        method: 'get',
    })
}
//获取账户余额
export function getAccount() {
    return request({
        url: `/services/company/account`,
        method: 'get',
    })
}

//获取接收方--船公司
export function getShippingCompany(params) {
    return request({
        url: serve2+`/agent/base/getSimpleCarrier`,
        method: 'get',
        params
    })
}
//获取码头
export function getPiers(params) {
    return request({
        url: `/services/apps/dataSend/vgm/list`,
        method: 'get',
        params
    })
}
//根据港口和接收方查通道
export function getRole(params) {
    return request({
        url: `/services/base/data/vgm/carrier/role`,
        method: 'get',
        params
    })
}